import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, TextField, Typography, Box } from "@mui/material";
import { spacing, Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Avatar from "@mui/material/Avatar";
import SnackBarUI from "../../common/SnackUI";
import { useNavigate, useSearchParams } from "react-router-dom";

import { uplodImageAction } from "../../redux/toolkit/image/uploadImage";
import { DevTool } from "@hookform/devtools";
import { appCategoryAction } from "../../redux/toolkit/apps/categories";
import { appEditAction } from "../../redux/toolkit/apps/edit";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { appDetailAction } from "../../redux/toolkit/apps/detail";

const app_schema = yup
  .object()
  .shape({
    // platform: yup.string().required("Platform is required."),
    app_name: yup.string().required("App Name is required."),
    app_logo: yup.string().required("App logo is required."),
    currency_name: yup.string().required("Currency Name is required."),
    currency_logo: yup.string().required("Currency Logo is required."),
    exchange_rate: yup
      .number()
      .typeError("Exchange Rate is always Number")
      .min(0, "Exchange rate can not less than 0")
      // .max(1000, "Can Not greater than 1000.")
      .positive("Exchanges Rate is always positive number")
      .required("Exchange Rate is required."),
    postback_url: yup.string().required("Exchange Rate is required."),
    // test_postback: yup.string().required('Test Postback is required.'),
    // screenout_payout: yup
    //   .number()
    //   .typeError("Screenout payout is always string...")
    //   .positive("screen out payout always a position number...")
    //   .min(0, "Screen Out payout can not below 0")
    //   .required("Screenout Payout is required."),
    user_commission: yup
      .number()
      .typeError("User Commission is always in number.")
      .max(100, "user commissin can not greater than 100")
      .positive("User commission always a positive number...")
      .required("User Commissin is required."),
    // ipSurveyLimit: yup
    //   .number()
    //   .typeError('IP Survey Limit must be a number.')
    //   .required("IP Survey Limit must be a number"),
    // attemptedSurveyLimit: yup
    //   .number()
    //   .typeError('Attempted Survey Limit must be a number.')
    //   .required("Attempted Survey Limit must be a number"),
    // callBackIpSurveyLimit: yup
    //   .number()
    //   .typeError('callBackIp Survey Limit must be a number.')
    //   .required("callBackIp Survey Limit must be a number"),
    // callBackCompletedSurveyLimit: yup
    //   .number()
    //   .typeError('callBackCompleted Survey Limit must be a number.')
    //   .required("callBackCompleted Survey Limit must be a number"),
    // callBackAttemptedSurveyLimit: yup
    //   .number()
    //   .typeError('callBackAttempted Survey Limit must be a number.')
    //   .required("callBackAttempted Survey Limit must be a number"),
    // commission: yup.number().required('Commission is required.'),
    appLink: yup
      .string()
      .typeError("App Link must be a string.")
      .required("App Link must be a string")
      .test(
        "is-not-number",
        "App Link must contain non-numeric characters.",
        (value) => isNaN(value) || /\D/.test(value) // Ensures it's not a pure number
      ),
    // callbackScreenoutSurveyLimit: yup
    //   .number().required('Call Back ScreenOut Survey Limit  is required.')
    //   .typeError('Call Back ScreenOut Survey Limit is always number'),
  })
  .required();

export default function UpdateApp() {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(app_schema),
    defaultValues: {},
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const app_id = searchParams.get("app_id");
  const [category, setCategory] = useState([]);
  const [platform, setPlatform] = useState();
  const [appLogo, setAppLogo] = useState();
  const [currLogo, setCurrLogo] = useState();
  const [snakbar, setSnakbar] = useState(false);
  const [theme, setTheme] = useState(null);
  const [adsEnabled, setAdsEnabled] = useState(false);

  console.log("appLogo=================>",appLogo)

  //   const [platformVal,setPlatformVal]=useState()
  const appCategory = useSelector((state) => state.appCategory);
  const { status, data, message, loading } = appCategory;

  const appDetail = useSelector((state) => state.appDetail);
  const {
    status: appDetailStatus,
    data: appData,
    message: appMsg,
    loading: appLoad,
  } = appDetail;

  const appEdit = useSelector((state) => state.appEdit);
  const { status: Status, data: Data, message: Msg, loading: Load } = appEdit;
  let categoriesId = appData.categories;



  useEffect(() => {
    dispatch(appCategoryAction());
    dispatch(appDetailAction(app_id));
  }, [dispatch]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.app_name = appData.app_name;
    defaultValues.currency_name = appData.currency_name;
    defaultValues.postback_url = appData.postback_url;
    defaultValues.user_commission = appData.user_commission;
    defaultValues.exchange_rate = appData.exchange_rate;
    defaultValues.appLink = appData.appLink;
    defaultValues.app_logo = appData.app_logo;
    defaultValues.currency_logo = appData.currency_logo;


    setAppLogo(appData.app_logo);
    setValue("app_logo", appData.app_logo, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setTheme((prevTheme) => appData.app_color);
    setValue("app_color", appData.app_color, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setCurrLogo(appData.currency_logo);
    setValue("currency_logo", appData.currency_logo, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    reset({ ...defaultValues });
  }, [appData]);

  const catNamesArray = data.map((obj) => obj.cat_name);

  const categoryArr = catNamesArray;
  const platformArr = ["Android", "IOS", "Web"];

  const handleAppSubmit = async (data) => {
    const submitnewArray = await appCategory.data
      .filter((obj) => category?.includes(obj.cat_name))
      .map((obj) => obj._id);

    if (submitnewArray.length === 0) {
      data.categories = categoriesId;
    } else {
      data.categories = submitnewArray;
    }

    const appStore = await dispatch(
      appEditAction({
        app_id: app_id,
        ...data,
        app_logo: appLogo,
        currency_logo: currLogo,
        platform: platform,
        app_color: theme,
        is_ads_enabled: adsEnabled,
      })
    );
    setSnakbar(true);
    setTimeout(() => {
      navigate("/apps");
    }, 1500);
  };

  const handleIconUpload = async (e) => {
    const formData = new FormData();

    formData.set("file", e.target.files[0]);

    let uploadedImg = await dispatch(uplodImageAction(formData));
    const imgStr = uploadedImg?.payload?.data?.url;
    setAppLogo(imgStr);
    setValue("app_logo", imgStr, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleIconUpload2 = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = async () => {
      // if (img.width > 25 || img.height > 25) {
      //   alert("Image dimensions should not exceed 25x25 pixels.");
      //   return;
      // }

      const formData = new FormData();
      formData.set("file", file);

      let uploadedImg = await dispatch(uplodImageAction(formData));
      const imgStr = uploadedImg?.payload?.data?.url;

      setCurrLogo(imgStr);
      setValue("currency_logo", imgStr, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    };
  };

  const handleSwitchChange = () => {
    setAdsEnabled((prev) => !prev);
  };
  const handleChange = async (e) => {
    setTheme(e.target.value);
    setValue("app_color", e.target.value, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  let matchedObjects;
  useEffect(() => {
    matchedObjects = categoryArr.filter((obj) =>
      appData.categories?.includes(obj._id)
    );
  }, [appData]);

  return (
    <>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        {appLoad ? (
          "loading.."
        ) : (
          <Card sx={{ p:{xs:2,sm:5}, border: "1px solid #000" }}>
            <Typography variant="h5" fontWeight={600} sx={{ mb: 5 }}>
              Edit App Details
            </Typography>

            <form onSubmit={handleSubmit(handleAppSubmit)}>
              <Stack spacing={3}>
                {/* Postback URL */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                >
                  <Box sx={{ width: "100%" }}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      {...register("postback_url")}
                      error={!!errors?.postback_url?.message}
                      helperText={errors?.postback_url?.message}
                      label="Post Back Url"
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Request method will be "POST".
                    </Typography>
                  </Box>
                </Stack>

                {/* App Name & Currency Name */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                >
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="App Name"
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      {...register("app_name")}
                      error={!!errors?.app_name?.message}
                      helperText={errors?.app_name?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please Mention The App Name
                    </Typography>
                  </Stack>

                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="Currency Name"
                      InputLabelProps={{ shrink: true }}
                      {...register("currency_name")}
                      error={!!errors?.currency_name?.message}
                      helperText={errors?.currency_name?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please mention the currency name that you are using in
                      your app. for eg: coins.
                    </Typography>
                  </Stack>
                </Stack>

                {/* Logos */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  alignItems="flex-start"
                >
                  {/* App Logo */}
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }} spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label="App Logo"
                        type="file"
                        id="app_logo"
                        {...register("app_logo")}
                        onChange={handleIconUpload}
                        error={!!errors?.app_logo?.message}
                        helperText={errors?.app_logo?.message}
                        fullWidth
                      />
                      <Avatar alt="App Logo" src={appLogo} />
                    </Stack>
                    <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                      Please Enter The App Logo
                    </Typography>
                  </Stack>

                  {/* Currency Logo */}
                  <Stack sx={{ width: { xs: "100%", sm: "50%" } }} spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label="Currency Logo"
                        type="file"
                        id="curr_logo"
                        {...register("currency_logo")}
                        error={!!errors?.currency_logo?.message}
                        helperText={errors?.currency_logo?.message}
                        onChange={handleIconUpload2}
                        fullWidth
                      />
                      <Avatar alt="Currency Logo" src={currLogo} />
                    </Stack>
                    <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                      Max size of the logo is 25x25 px.
                    </Typography>
                  </Stack>
                </Stack>

                {/* Exchange Rate & Commission */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                >
                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      label="Currency Conversion Rate"
                      {...register("exchange_rate")}
                      error={!!errors?.exchange_rate?.message}
                      helperText={errors?.exchange_rate?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      Please enter the currency value equivalent to 1$ in your
                      app.
                    </Typography>
                  </Box>

                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <TextField
                      label="User Commission"
                      {...register("user_commission")}
                      error={!!errors?.user_commission?.message}
                      helperText={errors?.user_commission?.message}
                      fullWidth
                    />
                    <Typography sx={{ my: 1, fontSize: 12, opacity: 0.7 }}>
                      User's rev share: This is the amount, you will be giving
                      to the users from your revenue.
                    </Typography>
                  </Box>
                </Stack>

                {/* App Link */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                >
                  <Box sx={{ width: "100%" }}>
                    <TextField
                      label="App Link"
                      {...register("appLink")}
                      error={!!errors?.appLink?.message}
                      helperText={errors?.appLink?.message}
                      fullWidth
                    />
                  </Box>
                </Stack>

                {/* Submit Button */}
                <Stack direction="row" justifyContent="center">
                  <Button
                    variant="contained"
                    sx={{
                      paddingInline: "40px",
                      width: { xs: "100%", sm: "auto" },
                      // background:
                      //   "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                      background:"#000",
                      '&:hover': {
                        background: "#000",
                      },
                      
                      textTransform: "none",
                      mt: { xs: 2, sm: 4 },
                      mb: 0,
                    }}
                    type="submit"
                  >
                    Update App
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        )}
      </BodyWapperUI>
      {snakbar && (
        <SnackBarUI
          state={snakbar}
          setState={setSnakbar}
          status={Status}
          message={Msg}
        />
      )}

      <DevTool control={control} />
    </>
  );
}
